import * as React from 'react'
import { TextField, TextFieldProps } from 'cs-kevlar-react/lib/es/TextField'
import { FormHelperText } from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import clsx from 'clsx'
import dotProp from 'dot-prop'
import { getIn } from 'formik'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formHelperTextPlaceholder: {
      minHeight: '1em',
    },
  }),
)

export type FormikTextFieldProps = TextFieldProps & {
  formikProps: any
  fieldName: string
  readOnly?: boolean
}

export const FormikTextField = ({
  formikProps,
  fieldName,
  helperText,
  readOnly,
  ...rest
}: FormikTextFieldProps) => {
  const hasError =
    getIn(formikProps.touched, fieldName) &&
    !!getIn(formikProps.errors, fieldName)
  const error = getIn(formikProps.errors, fieldName)
  const value = dotProp.get(formikProps.values, fieldName) ?? ''

  const classes = useStyles({})

  const currentHelperText = hasError ? error : helperText

  const inputProps = readOnly
    ? {
        readOnly: true,
      }
    : undefined

  // add a placeholder that is the same height as the error helper text
  return (
    <React.Fragment>
      <TextField
        error={hasError}
        helperText={currentHelperText}
        id={fieldName}
        onChange={formikProps.handleChange}
        onBlur={formikProps.handleBlur}
        value={value}
        InputProps={inputProps}
        {...rest}
      />
      {!hasError && (
        <FormHelperText
          error
          className={classes.formHelperTextPlaceholder}
        ></FormHelperText>
      )}
    </React.Fragment>
  )
}
